(ns app.front.view.property.v2.header
  (:require [app.domain.property.model :as property-model]
            [app.front.ui :as ui]
            [app.front.ui.separator :as ui-sep]
            [app.front.ui.status :as ui-status]
            [app.front.view.common.data-grid :as dg]
            [app.front.view.common.header :as header-common]
            [app.front.view.property.header :as property-header]
            [app.front.view.property.subs :as property-subs]
            [clojure.string :as str]
            [core.front.date-util :as date-util]
            [core.front.event :refer [<sub >evt]]
            [core.front.feature-flags :as ff]
            [core.front.icons :as i]
            [core.util.util :as util]))

(defn action-row [tr property]
  (let [full-prop-info-visible? (<sub [::property-header/full-property-info-visible?])
        can-edit?               (-> property :granted-permissions :permission.property/write)
        editing?                (boolean (<sub [::property-subs/editing?]))
        property-db-units?      (<sub [::ff/enabled? :feature-flag.id/property-db-units])]
    [:div
     [:div.flex.flex-row.justify-between
      [:div.flex.flex-col
       [:div.flex.flex-row.gap-2
        (when (and (not property-db-units?)
                   (-> property :entity/location))
          [header-common/toggle-map-or-property-data-button (util/mmap {:map-view-id   (:db/id property)
                                                                        :kind          :primary
                                                                        :visible-class "bg-black"}
                                                                       tr)])
        [ui/button {:kind          :primary
                    :size          :small
                    :icon          (if full-prop-info-visible? i/remove i/documents)
                    :class-name    (if full-prop-info-visible? "bg-black" "")
                    :icon-position :right
                    :on-click      #(>evt [::property-header/toggle-full-property-info-visibility])}
         (tr [(if full-prop-info-visible? :workspace/hide-full-data :workspace/show-full-data)])]
        (when can-edit?
          [ui/button {:kind          :primary
                      :size          :small
                      :icon          (if editing? i/remove i/pen)
                      :class-name    (if editing? "bg-black" "")
                      :icon-position :right
                      :on-click      #(>evt [::property-subs/set-editing
                                             (-> property :property/group :db/id)
                                             (not editing?)])}
           (tr [(if editing? :property-view/close-edit-btn :property-view/edit-property-btn)])])]]]
     [ui-sep/horizontal]]))

(defn prop-info [label content & [always-visible? critical-notice?]]
  (let [full-prop-info-visible? (<sub [::property-header/full-property-info-visible?])
        class                   (when critical-notice?
                                  (str (ui-status/status->border-color-class :attention) " border-l-6 border-solid"))]
    (when (and content (or always-visible? full-prop-info-visible?))
      [dg/grid-item {:label label
                     :class class}
       [:span content]])))

(defn property-data
  [tr {:property/keys [type legacy-attributes last-updated-from-gis]
       :as            property}]
  (let [property-description (when (-> property :property/from-st)
                               (tr [:property/from-to]
                                   [(:property/from-st property)
                                    (:property/to-st property)]))
        prop-keys            (concat (when (not= type :property.type/road)
                                       [:property/id])
                                     [:property/secondary-id
                                      :property/integration-id
                                      :property/description
                                      :property/legal
                                      :property/type-code
                                      :property/zoning
                                      :property/ward]
                                     (when (inst? last-updated-from-gis)
                                       [:property/updated-from-gis]))
        always-visible?      #{:property/id
                               :property/legal}
        attributes           (<sub [::property-subs/property-attributes-sorted])
        lang                 (<sub [:language])
        format-date          (<sub [::date-util/date-fn])]
    (->> (concat (->> prop-keys
                      (map (fn [k]
                             [prop-info
                              (tr [k])
                              (case k
                                :property/updated-from-gis ((<sub [::date-util/date-time-fn]) last-updated-from-gis)
                                :property/description property-description
                                (get property k))
                              (always-visible? k)])))
                 (map (fn [attr]
                        ^{:key (:db/id attr)}
                        [prop-info nil (:legacy-property-attribute/value attr)])
                      legacy-attributes)
                 (map (fn [{:property-attribute/keys [template] :as attr}]
                        ^{:key (:db/id attr)}
                        [prop-info
                         (property-model/attribute-template-name template lang)
                         (property-model/attribute-value attr lang tr format-date)
                         (-> template :property-attribute-template/pinned-in-groups seq)
                         (-> template :property-attribute-template/critical?)])
                      attributes))
         vec
         (into [dg/data-grid]))))

(defn header [tr property]
  [:div.mb-8
   [:div.flex.flex-row [:h2 (property-header/address-with-municipality-name tr property)]]
   [:div.flex.flex-row.my-2 (property-model/property-type-text tr property)]

   [action-row tr property]

   (if (<sub [::header-common/map-visible? (:db/id property)])
     [:div.flex.flex-col
      [:div.map-boundary.mb-4.md:mb-0.mr-6.w-full.bg-gray-400.flex.flex-shrink-0.items-center.justify-center.map-extended
       [property-header/map-wrapper property]]]

     [:div
      [:div.flex.flex-col
       [:div.flex.flex-row.gap-2.mb-2
        (when (= (:domain/state property) :property.state/historical)
          [ui/tag {:color      :blue
                   :type       :round
                   :class-name "ml-0 bg-cyan-400 text-black"}
           (str/upper-case (tr [:property.state/historical]))])
        (when (not (property-model/gis-verified? property))
          [ui/tag {:color      :blue
                   :type       :round
                   :class-name "ml-0"}
           (str/upper-case (tr [:property/data-source-user]))])]
       [property-data tr property]]])])
